import { render, staticRenderFns } from "./MeetingWrapper.vue?vue&type=template&id=3b3a0e92&lang=pug&"
import script from "./MeetingWrapper.vue?vue&type=script&lang=js&"
export * from "./MeetingWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src142773959/src/bsix_meet_client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b3a0e92')) {
      api.createRecord('3b3a0e92', component.options)
    } else {
      api.reload('3b3a0e92', component.options)
    }
    module.hot.accept("./MeetingWrapper.vue?vue&type=template&id=3b3a0e92&lang=pug&", function () {
      api.rerender('3b3a0e92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MeetingWrapper.vue"
export default component.exports